<template>
  <transition name="fade">
    <perfect-scrollbar class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4>Number Items</h4>
        <div class="subtitle">Add or edit number items visible on homepage,
          use this helper for displaying specific dynamic number:<br />
          <b>{</b><b>{volunter_count}</b><b>}</b> <b>{</b><b>{donation_total}</b><b>}</b> <b>
          {</b><b>{donation_program_count}</b><b>}</b>
          <b>{</b><b>{donor_count}</b><b>}</b> <b>{</b><b>{support_count}</b><b>}</b> <b>
          {</b><b>{supporter_count}</b><b>}</b>
        </div>
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup" :class="{hasError: form.title.error}">
            <label>Title</label>
            <input type="text" class="field" placeholder="Title..."
              v-model="form.title.model" v-on:input="form.title.error = null">
            <div class="fieldError" v-if="form.title.error">{{form.title.error}}</div>
          </div>
          <div class="fieldGroup" :class="{hasError: form.description.error}">
            <label>Descriptions</label>
            <input type="text" class="field" placeholder="Descriptions..."
              v-model="form.description.model" v-on:input="form.description.error = null">
            <div class="fieldError" v-if="form.description.error">{{form.description.error}}</div>
          </div>
          <div class="fieldGroup" :class="{hasError: form.link.error}">
            <label>Link</label>
            <input type="text" class="field" placeholder="Link url..."
              v-model="form.link.model" v-on:input="form.link.error = null">
            <div class="fieldError" v-if="form.link.error">{{form.link.error}}</div>
          </div>
          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!loading">Cancel</button>
            <button class="btn btnPrimary" :class="{btnLoading: loading}" type="submit">
              <span>Save Changes</span>
            </button>
          </div>
        </form>
      </div>
      <Confirmation ref="confirmDialog"/>
    </perfect-scrollbar>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: { Confirmation },
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      d: null,
      form: {
        title: { model: '', error: null },
        description: { model: '', error: null },
        link: { model: '', error: null },
      },
    };
  },
  methods: {
    open(d, n) {
      this.next = n;
      this.show = true;
      this.d = d;
      this.loading = false;
      this.form.title.model = (d && d.title) ? d.title : '';
      this.form.title.error = null;
      this.form.description.model = (d && d.description) ? d.description : '';
      this.form.description.error = null;
      this.form.link.model = (d && d.link) ? d.link : '';
      this.form.link.error = null;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    handleSubmit() {
      const formData = {
        title: this.form.title.model,
        description: this.form.description.model,
        link: this.form.link.model,
      };
      if (!formData.title || formData.title === '') {
        this.form.title.error = 'Please input title';
        return;
      }
      if (!formData.description || formData.description === '') {
        this.form.description.error = 'Please input descriptions';
        return;
      }
      if (this.d) formData.id = this.d.id;
      this.loading = true;
      this.$http.post(this.$config.uri('misc/config/home/number'), formData).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) return;
        this.close(true, r.data.data);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: .7;
      z-index: 1;
    }
    .modalContent{
      position: relative;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      overflow: hidden;
      max-width: none;
      width: 640px;
      box-sizing: border-box;
      // top: 50%; left: 50%;
      // transform: translate(-50%, -50%);
      margin: 40px auto;
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .subtitle{
        color: #767676;
        margin: -11px 0 20px;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.loading{
            background-color: #ccc;
            color: #999;
            cursor: default;
            box-shadow: none !important;
          }
        }
      }
    }
  }
</style>
